export function getDeviceOrientation() {
  if (typeof window !== 'undefined') {
    return window.innerHeight > window.innerWidth ? 'portrait' : 'landscape';
  }
  return undefined;
}
export function getDeviceBreakpoint() {
  var device = 'desktop';
  var mobileBp = 480;
  var tabletBp = 768;
  var orientation = getDeviceOrientation();
  var deviceSize = orientation === 'portrait' ? window.innerWidth : window.innerHeight;
  if (deviceSize < mobileBp) {
    device = 'mobile';
  } else if (deviceSize >= mobileBp && deviceSize <= tabletBp) {
    device = 'tablet';
  }

  // Additional check to ensure wide screens with a mouse are classified as desktop
  if (window.innerWidth > tabletBp && window.matchMedia('(pointer:fine)').matches) {
    device = 'desktop';
  }
  return device;
}